module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "project-view"
  }, [_c('div', {
    staticClass: "nav"
  }, [(!_vm.tbcMode) ? _c('router-link', {
    staticClass: "return-btn",
    attrs: {
      "to": _vm.upperPath || '/'
    }
  }, [_c('i', {
    staticClass: "ppj-icon-angle-left"
  }), _vm._v(_vm._s(_vm.$t('common.buttons.return')) + "\n    ")]) : _vm._e()], 1), _vm._v(" "), (_vm.loaded) ? _c('router-view', {
    staticClass: "sub-project-view"
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3504b370"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/project/index.vue
// module id = 908
// module chunks = 3